import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import BugReportModal from "components/Support/BugReportModal.js";

import routes from "routes.js";

import image1 from "assets/img/full-screen-image-1.jpg";
import image2 from "assets/img/full-screen-image-2.jpg";
import image3 from "assets/img/full-screen-image-3.jpg";
import image4 from "assets/img/full-screen-image-4.jpg";

/**
 * Admin layout — wraps all /admin/* protected routes.
 * In v6, nested routes are rendered via <Outlet /> rather than an internal <Routes>.
 * The actual route definitions live in index.js.
 *
 * The Sidebar still receives the routes config for nav rendering — that's unaffected
 * by the routing change since it only uses route metadata (name, path, icon).
 */
function Admin() {
  const [sidebarImage, setSidebarImage] = React.useState(image3);
  const [sidebarBackground, setSidebarBackground] = React.useState("black");

  return (
    <>
      <div className="wrapper">
        <Sidebar
          routes={routes}
          image={sidebarImage}
          background={sidebarBackground}
        />
        <div className="main-panel">
          <AdminNavbar />
          <div className="w-100 d-flex align-items-center pl-5" style={{ height: "130px", backgroundColor: 'black' }}>
            <img style={{ height: '90px' }} src={require('../assets/img/OrcaX Logo White.png')} alt="OrcaX" />
          </div>
          <div className="content" style={{ backgroundColor: "#FaF9F6" }}>
            {/* Renders whichever /admin/* child route matched */}
            <Outlet />
          </div>
          <AdminFooter />
          <div
            className="close-layer"
            onClick={() => document.documentElement.classList.toggle("nav-open")}
          />
        </div>
      </div>
      <FixedPlugin
        setSidebarImageParent={(value) => setSidebarImage(value)}
        sidebarDefaultImage={sidebarImage}
        sidebarImages={[image1, image2, image3, image4]}
        backgroundColors={["black", "azure", "green", "orange", "red", "purple"]}
        backgroundColor={sidebarBackground}
        setSidebarBackgroundParent={(value) => setSidebarBackground(value)}
      />
      <BugReportModal />
    </>
  );
}

export default Admin;
